export const conflictStatuses = {
  Open: { label: 'Open', color: 'danger', value: 1 },
  Pending: { label: 'Pending', color: 'warning', value: 2 },
  Resolved: { label: 'Resolved', color: 'primary', value: 3 },
  Opportunity: { label: 'Opportunity', color: 'success', value: 100 }
};
